<template>
  <div class="contanier">
    <div class="main" v-loading="loading">
      <div class="header">
        <div class="left">
          <div class="line-1"></div>
          <div class="line-2"></div>
          <span class="title">{{
            handleTitleChange($route.meta.type) + $t('applyChild.detail')
          }}</span>
        </div>
        <div class="right">
          <!-- <div class="shopBuy" @click="toShopPage">
            <el-badge :value="sumShopNum"  class="badgeBtn">
              <el-button icon="el-icon-shopping-cart-full"></el-button>
            </el-badge>
          </div> -->
          <el-button
            class="back-btn ml70"
            icon="el-icon-back"
            @click="returnBack"
            >{{$t('applyChildDetail.return')}}</el-button
          >
        </div>
      </div>
      <div class="detail-box">
        <div class="top">
          <div
            class="carousel"
            @mouseover="isIn = true"
            @mouseout="isIn = false"
          >
            <el-carousel
              :interval="cutTime"
              arrow="always"
              :autoplay="autoplay"
              trigger="click"
              :indicator-position="autoplay ? '' : 'none'"
              @change="getIndex"
            >
              <el-carousel-item
                v-for="(item, index) in dataSource.slidePhotoList"
                :key="index"
              >
                <div class="video-wrapper" v-if="item.type === 'video'">
                  <!--视频播放器 -->
                  <video :ref="'videoPlayer' + index" :controls="isIn">
                    <source :src="item.url" type="video/mp4" />
                    {{$t('goodsDetail.browserUnsupport')}}。
                  </video>
                  <i
                    v-show="!isPlay"
                    class="play-btn el-icon-video-play"
                    @click="playVideo"
                  ></i>
                  <i
                    v-show="isPlay && isIn"
                    class="play-btn el-icon-video-pause"
                    @click="pauseVideo"
                  ></i>
                </div>
                <viewer
                  :images="dataSource.slidePhotoList"
                  v-if="item.type === 'image'"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('goodsDetail.clickLargeImage')"
                    placement="top"
                  >
                    <img :src="item.url" class="img" />
                  </el-tooltip>
                </viewer>
              </el-carousel-item>
            </el-carousel>
            <!-- <div class="carousel-list">
                   <div class="list-item">
                    <img src="" />
                   </div>
                </div> -->
          </div>
          <div class="info-default">
            <p class="price-info row">
              <span class="unit">{{ dataSource.unit }}</span>
              <span class="price">{{ dataSource.price }}</span>
            </p>
            <div class="row">
              <div class="column">
                <div class="label">{{$t('applyChild.code')}}：</div>
                <div class="col">{{ dataSource.code }}</div>
              </div>
            </div>
            <span class="title-name">{{$t('warehouseDetail.name')}}： {{ dataSource.name }}</span>
            <div class="row">
              <div class="column">
                <div class="label">{{$t('applyChild.code')}}：</div>
                <div class="col">{{ dataSource.code }}</div>
              </div>
              <div class="column-1">
                <div class="label">{{$t('applyChild.model')}}：</div>
                <div class="col">{{ dataSource.model }}</div>
              </div>
            </div>
            <div class="row">
              <div class="column">
                <div class="label">{{$t('applyChild.size')}}：</div>
                <div class="col">
                 {{ dataSource.specification}}
                </div>
              </div>
            </div>

            <div class="brief">
              <span class="title">{{$t('goodsDetail.introduce')}}：</span>
              <p class="content">{{ dataSource.productDescribe || dataSource.partDescribe || dataSource.materialDescribe || '' }}</p>
            </div>
            <div class="instructions">
              <span class="title">{{$t('goodsDetail.instruction')}}：</span>
              <div class="item-list">
                <div
                  class="items"
                  v-for="(file, index) in explainList"
                  :key="index"
                  @click="downloadFile(file)"
                >
                  <div class="typeImg">
                    <img :src="file.resource" alt="" />
                  </div>
                  <div class="item-info">
                    <span class="title">{{ file.name }}</span>
                    <span class="size">{{ file.size }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div>
              <el-input-number
                v-model="shopNum"
                v-if="website.roleType == 'gen'"
                size="mini"
                :step="1"
                :min="1"
                :max="1000"
              ></el-input-number>
            </div> -->
            <div class="btns"  v-if="website.roleType == 'factory'">
              <!-- <el-button
                class="shop-btn"
                v-if="website.roleType == 'gen'"
                type="danger"
                @click="addShopping"
                >{{$t('goodsDetail.joinShopping')}}</el-button
              > -->
              <el-button class="delete-btn" @click="deleteItem">{{$t('authorityApiscope.delete')}}</el-button>
              <el-button class="edit-btn" @click="toEdit">{{$t('authorityApiscope.revise')}}</el-button>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div
            class="adList"
            v-for="(img, index) in dataSource.detail
              ? dataSource.detail.split(',')
              : []"
            :key="index"
          >
            <img :src="img" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getProductDetail,
  getPartDetail,
  getMaterialDetail,
  deleteProduct,
  deleteParts,
  deleteMaterial,
  getGeneralItemShoppingNumber,
  addGeneralShopping,
} from "@/api/goods/index";
import {
  onfileResourceChange,
  matchFileType,
  formatByte,
} from "@/util/fileType";

export default {
  components: {},
  data() {
    return {
      detailApi: null,
      deleteApi: null,
      dataSource: {
        slidePhotoList: [],
      },
      autoplay: true, //是否自动切换
      isPlay: false, //播放状态
      isIn: false, //鼠标是否位于播放器内
      cutTime: 5000, //轮播时间，单位毫秒
      loading: false,
      nowIndex: 0,
      explainList: [],
      shopNum: 1,
      sumShopNum: 0,
    };
  },
  computed: {
    id() {
      if (this.$route.query && this.$route.query.id) {
        return this.$route.query.id; 
      }
    },
    type() {
      if (this.$route.query && this.$route.query.type) {
        return this.$route.query.type;
      }
    }
  },
  created() {
    this.getDetail();
    this.getShopNum();
  },
  mounted() {
    //初始监听第一个视频
    this.listenVideo();
  },
  methods: {
    //获取走马灯的索引
    getIndex(nowIndex, oldIndex) {
      //用户可能在上个视频未播放完毕就切换
      //此时需要暂停上个视频并把时间归零，否则影响对当前视频的监听逻辑
      let myVideo = this.$refs["videoPlayer" + nowIndex];
      myVideo[0].pause();
      myVideo[0].currentTime = 0;
      this.nowIndex = nowIndex;
      this.listenVideo();
    },
    //监听视频的播放、暂停、播放完毕等事件
    listenVideo() {
      //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
      let myVideo = this.$refs["videoPlayer" + this.nowIndex];
      //监听播放
      myVideo[0].addEventListener("play", () => {
        this.autoplay = false;
        this.isPlay = true;
      });
      //监听暂停
      myVideo[0].addEventListener("pause", () => {
        this.autoplay = true;
        this.isPlay = false;
      });
      //监听播放完毕
      myVideo[0].addEventListener("ended", () => {
        //时间归零
        myVideo[0].currentTime = 0;
        this.autoplay = true;
        this.isPlay = false;
      });
    },
    //播放视频
    playVideo() {
      //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
      console.log(this.nowIndex);
      let myVideo = this.$refs["videoPlayer" + this.nowIndex];
      console.log("myVideo", myVideo);
      myVideo[0].play();
    },
    //暂停视频
    pauseVideo() {
      //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
      let myVideo = this.$refs["videoPlayer" + this.nowIndex];
      myVideo[0].pause();
    },
    // 说明书附件格式转换
    explainFormatter(arr, arr1, arr2) {
      let nameList = arr && arr.split(",");
      let urlList = arr1 && arr1.split(",");
      let sizeList = arr2 && arr2.split(",")|| [];
      if (nameList.length && urlList.length ) {
        urlList.map((x, idx) => {
          this.explainList.push({
            name: nameList[idx],
            url: x,
            resource: onfileResourceChange(matchFileType(nameList[idx])),
            size: formatByte(sizeList[idx]||0),
          });
        });
      }
      console.log("this.explainList", this.explainList);
    },
    handleTitleChange(e) {
      switch (e) {
        case "product":
          return this.$t('goodsDetail.product');
        case "part":
          return this.$t('goodsDetail.part');
        case "material":
          return this.$t('goodsDetail.material');
      }
    },
    handleApiChange(e) {
      switch (e) {
        case "product":
          return getProductDetail;
        case "part":
          return getPartDetail;
        case "material":
          return getMaterialDetail;
      }
    },
    handleDeleteApiChange(e) {
      switch (e) {
        case "product":
          return deleteProduct;
        case "part":
          return deleteParts;
        case "material":
          return deleteMaterial;
      }
    },
    returnBack() {
      this.$EvenBus.$emit("menuTag", this.$route.fullPath, "remove");
    },

    toShopPage() {
      this.$router.push({ path: `/shopping/child` });
    },
    // 下载附件
    downloadFile(item) {
      console.log("item", item);
      if (!item.url || item.url === "null") {
        this.$message.error(this.$t('complaintOrderDetail.noEnclosureAddress'));
        return;
      }
      const url = item.url;
      window.open(url);
    },
    // 编辑
    toEdit() {
      console.log(1123);
      this.$router.push({
        path: `/goods/${this.$route.meta.type}-edit`,
        query: {
          id: this.id,
          type: this.type
        },
      });
    },
    // 删除
    deleteItem() {
      let self = this;
      self.deleteApi = self.handleDeleteApiChange(self.$route.meta.type);
      self
        .$confirm(this.$t('faultDetail.sureDelete'), this.$t('lockIndex.tip'), {
          confirmButtonText: this.$t('indexTags.sure'),
          cancelButtonText: this.$t('indexTags.cancel'),
          type: "warning",
        })
        .then(async () => {
          const res = await self.deleteApi(this.id);
          if (res.data && res.data.code === 200) {
            self.$message({
              type: "success",
              message: this.$t('shoppingChild.deleteSuc')+'！',
            });
            setTimeout(() => {
              self.returnBack();
            }, 1000);
          }
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: this.$t('faultDetail.cancelDelete'),
          });
        });
    },
    // 获取详情
    async getDetail() {
      this.loading = true;
      this.detailApi = this.handleApiChange(this.$route.meta.type);
      const res = await this.detailApi( this.id);
      console.log("res------ =>", res.data);
      if (res.data && res.data.code === 200) {
        this.dataSource = res.data.data;
        this.dataSource.slidePhotoList = this.dataSource.slidePhotoList || [];
        const data = res.data.data || {}
        this.explainFormatter(
          data.productExplainName || data.partExplainName || data.materialExplainName || '',
          data.productExplain || data.partExplain || data.materialExplain || '',
          data.productExplainSize || data.partExplainSize || data.materialExplainSize || ''
        )
      }
      this.loading = false;
    },
    async getShopNum() {
      let res = await getGeneralItemShoppingNumber();
      console.log(res, "--getShopNum");
      this.sumShopNum = res.data.data;
    },
    async addShopping() {
      let res = await addGeneralShopping({ itemNumber: this.shopNum });
      console.log(res, "--addShopping");
      this.shopNum = 1;
      this.getShopNum();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #f0f2f5;
  height: 100%;
  overflow: auto;
}
.main {
  background-color: #fff;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    padding: 0 21px;
    .left {
      display: flex;
      align-items: center;
      .line-1 {
        width: 4px;
        height: 18px;
        background: #01aaa7;
        border-radius: 2px;
      }
      .line-2 {
        margin-left: 2px;
        width: 2px;
        height: 18px;
        background: #01aaa7;
        border-radius: 1px;
      }
      .title {
        margin-left: 9px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }
    .right {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      display: flex; flex-direction: row;;
      .back-btn {
        background-color: #01aaa7;
        color: #fff;
      }
    }
  }
  .detail-box {
    width: 760px;
    margin: 25px auto;
    border: 1px solid #e5e5e5;
    .top {
      display: flex;
      padding: 19px 18px;
      height: 100%;
      border-bottom: 1px solid #e5e5e5;
      .carousel {
        width: 354px;
        height: 100%;
        flex-shrink: 0;
        .el-carousel {
          width: 100%;
          height: 100%;
        }

        .el-carousel__container {
          width: 100%;
          height: 100%;
        }

        .el-carousel__item {
          width: 100%;
          height: 100%;
          border-radius: 10px;
          video {
            width: 100%;
            height: 100%;
            position: fixed;
            display: inline-block;
            vertical-align: baseline;
            object-fit: fill; //消除留白
          }
          .play-btn {
            font-size: 60px;
            color: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            &:hover {
              cursor: pointer;
            }
          }
          .img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .info-default {
        width: 100%;
        margin-left: 50px;
        .title-name {
          display: inline-block;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          margin-bottom: 14px;
        }
        .row {
          display: flex;
          align-items: center;
          // justify-content: space-between;
          flex-wrap: nowrap;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          margin-bottom: 10px;
        }
        .column {
          display: flex;
        }
        .column-1 {
          margin-left: 100px;
          display: flex;
        }
        .label {
          min-width: 20%;
        }
        .col {
          flex: 1;
        }
        .price-info {
          color: #fd894a;
          font-family: Source Han Sans CN;
          font-weight: 500;
          .unit {
            font-size: 12 * 0.8px;
          }
          .price {
            font-size: 16px;
          }
        }
        .brief {
          margin-top: 17px;
          display: flex;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          .title {
            min-width: 14%;
          }
        }
        .instructions {
          margin-top: 17px;
          display: flex;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          .title {
            min-width: 18%;
          }
          .title:hover {
            color: #1e90ff;
            text-decoration: underline;
          }
          .item-list {
            display: flex;
            flex-direction: column;
            .items {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              .typeImg {
                flex-shrink: 0;
                width: 32px;
                height: 32px;
                & > img {
                  width: 100%;
                  height: 100%;
                }
              }
              .item-info {
                display: flex;
                flex-direction: column;
                justify-content: center;
                .size {
                  font-size: 12px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #999999;
                }
              }
            }
            .items:hover {
              cursor: pointer;
            }
          }
        }
        .btns {
          margin-top: 41px;
          text-align: right;
          .delete-btn {
            border: 1px solid #50c4cb;
            color: #50c4cb;
          }
          .edit-btn {
            background-color: #50c4cb;
            color: #fff;
          }
          .shop-btn {
            border: 1px solid #f56c6c;
            color: #fff;
          }
        }
      }
    }
    .bottom {
      padding: 24px 20px;
      .adList {
        height: calc(100vh);
        & > img {
          width: 100%;
          height: 100%;
          vertical-align: bottom;
        }
      }
    }
  }
}
.badgeBtn {
  .el-button {
    border: none !important;
    padding: 5px 6px;
    margin: 0 5px 0 10px;
    color: #50c4cb;
    .el-icon-shopping-cart-full::before {
      font-size: 18px !important;
    }
  }
  /deep/ .el-icon-shopping-cart-full {
    font-size: 26px !important;
  }
}
</style>
